import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { widgetServices } from "../../../APIServices/SitePilotManagement/widgetServices";

const AddWidget = ({ show, hide, title, getWidgetList }) => {
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewWidget = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    let data = await widgetServices.addNewWidget(userData)
    if (data?.statusCode === 200) {
      getWidgetList()
      clearData();
    }
    setLoader(false)
  }
  
  const clearData = () => {
    setName("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setLoader(false)
    }
  }, [show]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Widget Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Widget Name"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!name || loader}
              onClick={addNewWidget}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddWidget;
